import React, { useContext, useState } from 'react'
import { Card, Row, Col } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import PropTypes from 'prop-types';
import CLabel from '../../../../../Common/CLabel'
import moment from 'moment';
import { useBoolean } from '@fluentui/react-hooks';
import './style-card.css'
import { ActionButton, ScrollablePane, ScrollbarVisibility } from '@fluentui/react';
import GapRevisionInfoTool from '../GapRevisionInfoBox';
import SidePanelViewAllAction from '../Fishbone/SidePanelViewAllAction';
import MainAppContext from '../../../../../../MainAppContext';
import GapAppContext from '../../../../../../GapAppContext';
import SidePanelAddRevision from '../../../DialogGenerateGap/SidePanelAddRevision';
import { __OBJECT_STRUCTURE_GetList } from '../../../../../../common/ObjectStructures/Trasnversal';
import { _checkSecurityUser } from '../../../../../../common/Helpers/HLP_Security';
import { __enum_PageMode, enum__PRIVILEGES, enum__RevisionStatus } from '../../../../../../common/Dictionaries';
import { isNullUndefinedOrEmpty } from '../../../../../../common/Helpers';

function GapRevisionsBox(props) {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const contextGap = useContext(GapAppContext);

    const [hideDialog, { toggle: toggleHideDialog }] = useBoolean(true);
    const [isAddRevisionPanelOpen, setIsAddRevisionPanelOpen] = useState(false);
    const [isProcessRevisionPanelOpen, setIsProcessRevisionPanelOpen] = useState(false);
    const {
        inputParam_GapAnalyzeId = null,
        inputParam_SetterSelectedRevision = null,
        inputParam_GapElementId = null,
        inputParam_SetFireGetLastActions = null,
        gapRevisionsList = null,
        setGapRevisionsList = null,
        gapRevisionsListFiltred = null,
        setGapRevisionsListFiltred = null,
        selectedRevision = null,
    } = props;
    const [filterText, setFilterText] = useState('')
    const [gapAnalyzeIdToAddRevisionId, setGapAnalyzeIdToAddRevisionId] = useState(null);
    const [gapAnalyzeNameToAddRevisionId, setGapAnalyzeNameToAddRevisionId] = useState(null);
    //const [selectedRevisionId, setSelectedRevisionId] = useState(gapRevisionsList.data.length > 0 ? gapRevisionsList.data[0].id : null);
    const selectedRevisionId = gapRevisionsListFiltred.data.length > 0 ? (selectedRevision !== null ? selectedRevision.id : gapRevisionsListFiltred.data[0].id) : null
    const [selectedRevisionStatusId, setSelectedRevisionStatusId] = useState(null);
    
    const _priv_canProcessGapRevision = _checkSecurityUser(contextGap.userPropsKpi.value.onlyObserver, contextGap.userPropsKpi.value, contextSite.securityProps, inputParam_GapElementId, enum__PRIVILEGES.GAP_CONTRACT_APROVE)
    
    const _priv_canAddGapRevision = _checkSecurityUser(contextGap.userPropsKpi.value.onlyObserver, contextGap.userPropsKpi.value, contextSite.securityProps, inputParam_GapElementId, enum__PRIVILEGES.GAP_CONTRACT_ANALYZE)


    const onSelectRevisionClick = (revision) => {
        inputParam_SetterSelectedRevision && inputParam_SetterSelectedRevision(revision, gapRevisionsList)
        //inputParam_SetterDataToNull && inputParam_SetterDataToNull()
    }

    const onProcessRevision = (revisionStatusId) => {
        setSelectedRevisionStatusId(revisionStatusId)
        setIsProcessRevisionPanelOpen(true)
    }

    const onOpenRevisionPanel = (gapAnalyzeId, gapAnalyzeName) => {
        setIsAddRevisionPanelOpen(true);
        setGapAnalyzeIdToAddRevisionId(gapAnalyzeId);
        setGapAnalyzeNameToAddRevisionId(gapAnalyzeName)
    }

    const onRenderAditionalRevisionInformationElement = (revisionStatusId, revisionId, resisionStatusId) => {
        return <div className='d-flex'>
                    <div>
                        {
                            (_priv_canProcessGapRevision.value && _priv_canProcessGapRevision.mode === __enum_PageMode.Edit) && resisionStatusId < enum__RevisionStatus.GAP_REVISION_END &&
                            <ActionButton onClick={ () => onProcessRevision(revisionStatusId) } iconProps={{ iconName: 'Share' }} allowDisabledFocus>
                                { t('data-lang-btn-process') }
                            </ActionButton>
                        }
                        {
                            !(_priv_canProcessGapRevision.value && _priv_canProcessGapRevision.mode === __enum_PageMode.Edit) &&
                            <ActionButton onClick={ () => onProcessRevision(revisionStatusId) } iconProps={{ iconName: 'View' }} allowDisabledFocus>
                                { t('data-lang-boxname-actionlist') }
                            </ActionButton>
                        }
                    </div>
                    <div>
                        <GapRevisionInfoTool
                            inputParam_GapAnalyzeId={ inputParam_GapAnalyzeId }
                            inputParam_GapRevisionId={ revisionId }
                            inputParam_GapSelectedRevisionId={ selectedRevisionId }
                            inputParam_GapElementId={inputParam_GapElementId}
                            inputParam_ToggleHideDialog={toggleHideDialog}
                            inputParam_HideDialog={hideDialog}
                            inputParam_SetFireGetLastActions={inputParam_SetFireGetLastActions}
                        />
                    </div>
                </div>
    }

    const onChangeFilterText = (event) => {
        setFilterText(event.target.value)

        const aux_data = !isNullUndefinedOrEmpty(event.target.value) ? gapRevisionsList.data.filter(x =>
            x.title.toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1 ||
            (t(`data-lang-skrevision-status${x.statusId}`)).toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1 ||
            ('rev' + x.id).toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1) : gapRevisionsList.data

        setGapRevisionsListFiltred && setGapRevisionsListFiltred(prevState => ({
            ...prevState,
            data: aux_data
        }));
    }

    return (
        <>
            <Card className='h-100'>
                <Card.Header className="card-header-compact">
                    <Card.Title className="d-flex justify-content-between">
                        <b>{t('data-lang-boxname-gaprevisions')}</b>
                        <div className='book-toolbar d-flex float-end'>
                            {
                                (_priv_canAddGapRevision.value && _priv_canAddGapRevision.mode === __enum_PageMode.Edit) &&
                                <ActionButton
                                    onClick={ () => onOpenRevisionPanel(inputParam_GapAnalyzeId, inputParam_GapAnalyzeId) }
                                    iconProps={{ iconName: 'Share' }}
                                    allowDisabledFocus
                                    id='btnNewRevision'
                                >
                                    { t('data-lang-btn-addrevision2') }
                                </ActionButton>
                            }
                        </div>
                    </Card.Title>
                </Card.Header>
                <Card.Footer style={{padding: "0px", borderBottom: "1px solid rgba(0, 0, 0, 0.125)"}}>
                    <div className='book-toolbar w-100 p-2'>
                        <Row>
                            <Col className='col-auto text-start'><b>{t('data-lang-lbl-filter')}</b></Col>
                            <Col className='text-end'>
                                <input type='text' className='w-100' value={filterText} onChange={onChangeFilterText} />
                            </Col>
                        </Row>
                    </div>
                </Card.Footer>
                <Card.Body className="h-100 p-0">
                    <div>
                        <Row>
                            <Col>
                                <ScrollablePane
                                    style={{ minHeight: "242px", maxHeight: "100%", height: "100%"}}
                                    styles={{
                                        root: { position: "relative" },
                                        contentContainer:{overflowX: "hidden"}
                                    }}
                                    scrollbarVisibility={ScrollbarVisibility.auto}
                                    scrollContainerFocus={true}
                                >
                                    {
                                        gapRevisionsListFiltred.data !== null && gapRevisionsListFiltred.data.map((revision, index) => (
                                            <div key={index} className="pb-1">
                                                <Row className={` d-sm-flex d-none cursor-pointer ps-2${selectedRevisionId === revision.id ? " revision-selected" : ""}`} onClick={() => onSelectRevisionClick(revision)}>
                                                    <Col xl={8} className='me-0 pe-0'>
                                                        <Row>
                                                            <Col xs={6} xl={6} className='border-end border-info'>
                                                                <div className='pt-0'>
                                                                    {`(REV${revision.id}) - ${t('data-lang-lbl-revision')} - ${moment(revision.referenceDate).format('YYYY/MM/DD')}`}
                                                                </div>
                                                                <div className='pt-0 mt-0' style={{fontSize: "11px"}}>({revision.author})</div>
                                                            </Col>
                                                            <Col xs={6} xl={6} className='border-end border-info ps-1'>
                                                                <div className='pt-0'>
                                                                    {t('data-lang-lbl-status') + ": " + t(`data-lang-skrevision-status${revision.statusId}`)}
                                                                </div>
                                                                <div className='pt-0 mt-0' style={{fontSize: "11px"}}>({`${revision.periodId}`})</div>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col id='rowProcessGap' className='col-auto ms-auto'>
                                                        {
                                                            onRenderAditionalRevisionInformationElement(revision.statusId, revision.id, revision.statusId)
                                                        }
                                                    </Col>
                                                </Row>
                                                <Row className={`d-flex d-sm-none cursor-pointer ps-2${selectedRevisionId === revision.id ? " revision-selected" : ""}`} onClick={() => onSelectRevisionClick(revision.id)}>
                                                    <Row>
                                                        <Col>
                                                            <CLabel className='pt-2' labelText={t('data-lang-lbl-date')} labelValue={moment(revision.referenceDate).format('DD/MM/YYYY')} />
                                                        </Col>
                                                        <Col id='rowProcessGap'>
                                                            {
                                                                onRenderAditionalRevisionInformationElement(revision.statusId, revision.id)
                                                            }
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <CLabel className='pt-2' labelText={t('data-lang-lbl-period')} labelValue={revision.periodId} />
                                                        </Col>
                                                        <Col>
                                                            <CLabel className='pt-2' labelText={t('data-lang-lbl-status')} labelValue={revision.statusId} />
                                                        </Col>
                                                    </Row>
                                                </Row>
                                            </div>
                                        ))
                                    }
                                </ScrollablePane>
                            </Col>
                        </Row>
                    </div>
                </Card.Body>
            </Card>
            {
                inputParam_GapAnalyzeId !== null && gapAnalyzeIdToAddRevisionId !== null &&
                <SidePanelAddRevision 
                    inputParam_GapAnalyzeId={gapAnalyzeIdToAddRevisionId}
                    inputParam_GapElementId={inputParam_GapElementId}
                    inputParam_GapRevisionId={null}
                    inputParam_GapAnalyzeName={gapAnalyzeNameToAddRevisionId}
                    inputParam_IsPanelOpen={isAddRevisionPanelOpen}
                    inputParam_SetterIsPanelOpen={setIsAddRevisionPanelOpen}
                    inputParam_EditMode={false}
                    inputParam_SetRevisionList={setGapRevisionsList}
                    inputParam_RevisionList={gapRevisionsList.data}
                    SidePanelAddRevision
                />
            }
            <SidePanelViewAllAction
                inputParam_EditMode={(_priv_canProcessGapRevision.value && _priv_canProcessGapRevision.mode === __enum_PageMode.Edit)}
                inputParam_GapAnalyzeId={inputParam_GapAnalyzeId}
                inputParam_GapRevisionId={selectedRevisionId}
                inputParam_IsPanelOpen={isProcessRevisionPanelOpen}
                inputParam_SetterIsPanelOpen={setIsProcessRevisionPanelOpen}
                inputParam_SelectedRevisionStatusId={selectedRevisionStatusId}
                inputParam_GapElementId={inputParam_GapElementId}
                inputParam_GapRevisionsList={gapRevisionsList.data}
                inputParam_SetGapRevisionsList={setGapRevisionsList}
                
            />
        </>
    );
}

GapRevisionsBox.propTypes = {
    inputParam_GapAnalyzeId: PropTypes.number,
    inputParam_GapElementId: PropTypes.number,
    inputParam_SetterSelectedRevision: PropTypes.func,
    inputParam_SetterDataToNull: PropTypes.func,
};

export default GapRevisionsBox;

